import type { ReactNode } from 'react';
import { useRouter } from './RouterContext';

export type RouteDefinition = {
  path: string;
  element: ReactNode;
};

type RouterProps = {
  routes: RouteDefinition[];
  fallback?: ReactNode;
};

export function Router({ routes, fallback }: RouterProps) {
  const { pathname } = useRouter();

  for (const route of routes) {
    if (matchRoute(route.path, pathname)) {
      return <>{route.element}</>;
    }
  }

  return <>{fallback ?? null}</>;
}

function matchRoute(pattern: string, path: string): boolean {
  if (pattern === path) return true;

  const patternParts = pattern.split('/').filter(Boolean);
  const pathParts = path.split('/').filter(Boolean);

  if (patternParts.length !== pathParts.length) return false;

  return patternParts.every((part, i) => part.startsWith(':') || part === pathParts[i]);
}
